import React from 'react';
import { Box, Container, Grid, Section, Text } from '@radix-ui/themes';
import { useSelector } from 'react-redux';
import { selectDevice } from 'store/slices/common';

import Visual from 'components/common/visual';
import Breadcrumbs from 'components/common/breadcrumbs';
import PageTitle from 'components/layout/pageTitle';

import './style.scss';

export default function PromotionSystem() {
  const deviceType = useSelector(selectDevice);
  const isMobile = deviceType === 'mobile';

  return (
    <>
      <Visual category="introduction" title="소개" />
      <Breadcrumbs category="introduction" />
      <Section p="0" pb={isMobile ? 'var(--space-18)' : 'var(--space-35)'} className="promotion-system-wrap">
        <Container size={isMobile ? '1' : '4'}>
          <PageTitle icon="school" title="사업 추진체계" />

          <Box mb={isMobile ? 'var(--space-9)' : 'var(--space-20)'} className="system-box">
            <Text as="p" mb={isMobile ? 'var(--space-2)' : 'var(--space-6)'} className={isMobile ? 'sub-title' : 'title5'}>
              사업 추진체계
            </Text>
            <Text as="p" mb={isMobile ? 'var(--space-4)' : 'var(--space-10)'} className="body2">
              정보소외지역 SW교육지원강화사업의 <span className="font-bold">정책 및 기본방향 수립</span>(과학기술정보통신부),&nbsp;
              <span className="font-bold">전담기관</span>
              (정보통신산업진흥원)은 총괄 운영, 교육거점(SW미래채움센터)으로 구성됨
            </Text>
            <img src={require('assets/images/pages/intro/intro-map02.svg').default} alt="사업 추진체계 조직도" aria-hidden="true" />
            <ul className="visually-hidden">
              <li>
                과학기술정보통신부: 정책 및 기본방향 수립
                <ul>
                  <li>
                    정보통신산업진흥원(전담기관): 총괄 운영
                    <ul>
                      <li>
                        교육거점(SW미래채움센터, 주관기관): SW교육 인프라 운영 및 관리, 지역 초·중등학생 대상 방문SW교육 수행, 지역 인재
                        대상 SW전문강사 양성 및 채용연계
                      </li>
                    </ul>
                  </li>
                  <li>지방자치단체: 지자체 내 SW교육환경 조성을 위한 지원(예산매칭 등)</li>
                </ul>
              </li>
            </ul>
          </Box>

          <Box className="grid-box">
            <Text as="p" mb={!isMobile ? 'var(--space-6)' : 'var(--space-4)'} className={isMobile ? 'sub-title' : 'title5'}>
              추진 주체별 주요 역할
            </Text>
            <Grid columns={!isMobile ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)'} gap={!isMobile ? 'var(--space-5)' : 'var(--space-2)'}>
              {/* 1 */}
              <Box
                py={!isMobile ? 'var(--space-7)' : 'var(--space-4)'}
                px={!isMobile ? 'var(--space-7)' : 'var(--space-5)'}
                className="role-box"
              >
                <Text as="p" mb="var(--space-2)" className={isMobile ? 'body1 font-bold' : 'sub-title'}>
                  과학기술정보통신부
                </Text>
                <ul className="dots">
                  <li className="body2">사업기획 및 시행계획 수립</li>
                  <li className="body2">신규과제 수행기관 확정</li>
                </ul>
              </Box>
              {/* 2 */}
              <Box
                py={!isMobile ? 'var(--space-7)' : 'var(--space-4)'}
                px={!isMobile ? 'var(--space-7)' : 'var(--space-5)'}
                className="role-box"
              >
                <Text as="p" mb="var(--space-2)" className={isMobile ? 'body1 font-bold' : 'sub-title'}>
                  정보통신산업진흥원
                </Text>
                <ul className="dots">
                  <li className="body2">사업 세부추진계획 수립</li>
                  <li className="body2">
                    신규 및 결과평가 계획(안) 수립·시행
                    <ul className="dash">
                      <li>- 외부 전문가로 구성된 평가위원회를 통해 평가 진행</li>
                    </ul>
                  </li>
                  <li className="body2">사업 진도 및 성과관리</li>
                </ul>
              </Box>
              {/* 3 */}
              <Box
                py={!isMobile ? 'var(--space-7)' : 'var(--space-4)'}
                px={!isMobile ? 'var(--space-7)' : 'var(--space-5)'}
                className="role-box"
              >
                <Text as="p" mb="var(--space-2)" className={isMobile ? 'body1 font-bold' : 'sub-title'}>
                  지방자치단체
                </Text>
                <ul className="dots">
                  <li className="body2">지자체 內 SW교육환조성을 위한 지원(예산매칭 등)</li>
                </ul>
              </Box>
              {/* 4 */}
              <Box
                py={!isMobile ? 'var(--space-7)' : 'var(--space-4)'}
                px={!isMobile ? 'var(--space-7)' : 'var(--space-5)'}
                className="role-box"
              >
                <Text as="p" mb="var(--space-2)" className={isMobile ? 'body1 font-bold' : 'sub-title'}>
                  주관기관
                </Text>
                <ul className="dots">
                  <li className="body2">
                    정보소외지역SW교육지원강화사업(SW미래채움) 추진
                    <ul className="dash">
                      <li>- SW교육 인프라 운영 및 관리 등</li>
                      <li>- 지역 초‧중등학생 대상 방문SW교육(맞춤형‧찾아가는 SW교육 등) 수행</li>
                      <li>- 지역 인재(미취업청년, 경력단절여성, 퇴직전문가 등) 대상 SW전문강사 양성 및 채용연계 등</li>
                    </ul>
                  </li>
                </ul>
              </Box>
            </Grid>
          </Box>
        </Container>
      </Section>
    </>
  );
}
